// URLs that don't need authorization header
export const PUBLIC_URLS = ['/auth/'] as const;
export const IGNORE_PUBLIC_URLS = ['/auth/signup/questions'] as const;
